import React from 'react'
import { useSelector } from 'react-redux'

const Spinner = props => {

	const SpinnerState = useSelector(state => state.SpinnerState)

	const getClasses = () => {
		let classes = ["spinner"]
		if(SpinnerState.show) classes.push("spinner--show")
		return classes.join(" ")
	}

	return (
		<div className={getClasses()}>
			<div className="spinner__container">
				<div className="spinner__grid" aria-hidden="true">
					<span />
					<span />
					<span />
					<span />
					<span />
					<span />
					<span />
					<span />
					<span />
				</div>
			</div>
		</div>
	)
}

export default Spinner
